export const QuerySellingHours = `fragment FootballSellingHoursFragment on FootballSellingHoursRow {
  key: name
  date {
    value: dateValue
  }
  matchDate {
    value
  }
  digitalChannel {
    value
  }
  telebet {
    value
  }
  telebetAutomated {
    value
  }
  branch {
    value
  }
  racecourses {
    value
  }
}
fragment FootballSellingHoursDatasetFragment on FootballSellingHoursDataset{
  key: name    
  datasetDisplayName{
    value
  }
   data: children {
        ...FootballSellingHoursFragment
  }
}

query FootballSellingHoursQuery($lang: String!) {
  Content: item(path: "/sitecore/content/Sites/JCBW/Information/Special/Special Page/info/football/selling-hours/", language: $lang) {
    title: field(name: "PageTitle") {
      value
    }
    footnote: field(name: "Footer"){
            value
    }
    data: children {  
      ...FootballSellingHoursDatasetFragment
    }
  }
}
`;
